import { ConfigProvider, Form } from 'antd';
import { Input, Button, Typography } from "mobily-ui-library/lib";
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';

import './NotifyForm.scss';
import { sendOtp } from '../../api/api';
import { encrypt } from '../../utils';

interface Props {
    setSuccess: (value: boolean) => void;
    rtl: boolean;
    packages: any;
    center: any;
}

function NotifyForm({ setSuccess, rtl, packages, center }: Props) {
    const [fullName, setFullName] = useState('');
    const [idNumber, setIDNumber] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [buildingNumber, setBuildingNumber] = useState('');
    const [units, setUnits] = useState('');
    const [email, setEmail] = useState('');
    const [checked, setChecked] = useState(false);

    const { state, dispatch }: any = useContext(GlobalContext);
    const location = `${state.center.lat}, ${state.center.lng}`;
    const zipcode = state.mapData.zipcode;
    const category = state.gisZone?.Data?.Category ? state.gisZone.Data.Category : 'A';
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const direction = rtl ? 'rtl' : 'ltr';

    useEffect(() => {
        const child = document.createElement('a');
    
        const inputElement: any = document.getElementsByClassName('buildingNumber_TextField');
        const childElement = inputElement[0]?.children[2]?.children[0];

        child.innerText = 'National Address | Saudi Post | SPL';
        child.setAttribute('href', 'https://splonline.com.sa/en/national-address-1/');
        child.setAttribute('target', '_blank');

        childElement.appendChild(child);

        return () => {
            childElement.removeChild(child);
        }
    }, []);

    useEffect(() => {
        dispatch({ type: 'SET_LOADER', payload: false });
    }, [dispatch]);

    const handleSubmitForm = async (values: any) => {
        console.log(values, 'values')
        dispatch({ type: 'SET_LOADER', payload: true });
        const data = {
            "FullName": values.fullName,
            "IDNumber": values.idNumber,
            "ContactNumber": values.phoneNumber,
            "Email": values.email,
            "BuildingNumber": values.buildingNumber,
            "NumberOfUnits": values.units,
            "Location": {
              "Latitude": state.center.lat?.toString(),
              "Longitude": state.center.lng?.toString()
            },
            "ZoneZipCode": zipcode,
            "Category": category
        }
        const otpData = {
            "version": "v1",
            "journey": "ODB_SETUP_FEE",
            "operation": "SEND_OTP",
            "language": "en",
            "extraInfo": [
              {
                "key": "ACCOUNT_NUMBER",
                "value": encrypt(phoneNumber)
              },
              {
                "key": "OTP_LENGTH",
                "value": "4"
              },
              {
                "key": "IS_NUMERIC",
                "value": "Y"
              }
            ]
        }
        const res = await sendOtp(otpData);
        dispatch({ type: 'SET_MSISDN', payload: { msisdn: res.data?.data?.msisdn, refId: res.data?.data?.refId, smsSentTo: res.data?.data?.smsSentTo } });
        dispatch({ type: 'UPDATE_PAGE', payload: 'otp' });
        dispatch({ type: 'FORM_DATA', payload: data })
    }


    const handleNoUnit = (value: any) => {
        if (value > 300) {
            setTimeout(() => {
                form.setFields([
                    {
                        name: "units",
                        errors: [t('Unit_validation')],
                    },
                ]);
            }, 0)
        }

        setUnits(value);

    }

    const handleCheckbox = () => {
        setChecked(prevState => !prevState)
    }

    return (
        <div className='Notify__Form'>
            <ConfigProvider direction={direction}>
                <Form form={form} name="control-ref" onFinish={handleSubmitForm}>
                    <Form.Item
                        initialValue={fullName}
                        hasFeedback
                        name='fullName'
                        className={'form__fieldItem'}
                        rules={[
                            { required: true, message: t('FullName_validation') },
                            {
                                message: t('FullName_validation'),
                                pattern: /^[a-zA-Z][a-zA-Z\s]*$/
                            },
                            {
                                message: t('FullName_exceed_length'),
                                pattern: /^.{1,200}$/
                            }
                        ]}
                    >
                        <Input
                            rtl={rtl}
                            placeholder={t('Your_fullName')}
                            headingleft={t('Full_name')}
                            className='receiverName_inputField'
                            width={'410px'}
                            onChange={(e: any) => setFullName(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        initialValue={idNumber}
                        hasFeedback
                        name='idNumber'
                        className={'form__fieldItem'}
                        rules={[
                            { required: true, message: t('IDNumber_validation') },
                            {
                                message: t('IDNumber_validation'),
                                pattern: /^[0-9]{1,13}$/
                            }
                        ]}
                    >
                        <Input
                            rtl={rtl}
                            placeholder="XX XX XX XX XX"
                            headingleft={t('ID_number')}
                            headingright={t('ID_Type')}
                            labelleft={t('IdNumber_description')}
                            onChange={(e: any) => setIDNumber(e.target.value)}
                        />
                    </Form.Item>

                    <Form.Item
                        initialValue={phoneNumber}
                        hasFeedback
                        name='phoneNumber'
                        className={'form__fieldItem'}
                        rules={[
                            { required: true, message: t('MobileNumber_validation') },
                            {
                                message: t('MobileNumber_validation'),
                                pattern: /^((9665)([0-9]{8}))$/
                            }
                        ]}
                    >
                        <Input
                            rtl={rtl}
                            placeholder='9665XXXXXXXX'
                            headingleft={t('Mobile_number')}
                            labelleft={t('phoneNumber_description')}
                            maxLength={12}
                            onChange={(e: any) => setPhoneNumber(e.target.value)}
                        />
                    </Form.Item>

                    <Form.Item
                        hasFeedback
                        initialValue={email}
                        name='email'
                        className={'form__fieldItem'}
                        rules={[
                            { required: true, message: t('Email_missing') },
                            {
                                message: t('Email_validation'),
                                pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
                            }
                        ]}
                    >
                        <Input
                            rtl={rtl}
                            placeholder="email@address.com"
                            headingleft={t("Email")}
                            onChange={(e: any) => setEmail(e.target.value)}
                        />
                    </Form.Item>

                    <Form.Item
                        hasFeedback
                        initialValue={buildingNumber}
                        name='buildingNumber'
                        className={'form__fieldItem'}
                        rules={[
                            { required: true, message: t('Building_validation') },
                            {
                                message: t('Building_validation'),
                                pattern: /^[0-9]{4}$/
                            }
                        ]}
                    >
                        <Input
                            rtl={rtl}
                            placeholder={'XXXX'}
                            headingleft={t('Building_number')}
                            className='buildingNumber_TextField'
                            labelleft={`${t('Building_number_details')}`}
                            maxLength={4}
                            onChange={(e: any) => setBuildingNumber(e.target.value)}
                        />
                    </Form.Item>

                    <Form.Item
                        hasFeedback
                        initialValue={units}
                        name='units'
                        className={'form__fieldItem'}
                        rules={[
                            { required: true, message: t('Unit_validation') },
                            {
                                message: t('Unit_validation'),
                                pattern: /^[0-9]{1,3}$/
                            },
                        ]}
                    >
                        <Input
                            rtl={rtl}
                            placeholder="XXX"
                            value={units}
                            maxLength={3}
                            headingleft={t("Units")}
                            labelleft={t('units_description')}
                            onChange={(e: any) => handleNoUnit(e.target.value)}
                        />
                    </Form.Item>


                    <div className='horizontalLine' />

                    <Form.Item
                        hasFeedback
                        className={'form__fieldItem'}
                        rules={[{ required: false, message: t('') }]}
                    >
                        <Input
                            rtl={rtl}
                            readOnly
                            placeholder={t('Location')}
                            headingleft={t('Location')}
                            className='deliveryNotes_TextField'
                            value={location}
                        />
                    </Form.Item>

                    <Form.Item
                        hasFeedback
                        className={'form__fieldItem'}
                        rules={[{ required: false, message: t('') }]}
                    >
                        <Input
                            rtl={rtl}
                            readOnly
                            placeholder={t('Zip_Code')}
                            headingleft={t('Zip_Code')}
                            className='deliveryNotes_TextField'
                            value={zipcode}
                        />
                    </Form.Item>

                    <Form.Item
                        hasFeedback
                        className={'form__fieldItem'}
                        rules={[{ required: false, message: t('') }]}
                    >
                        <Input
                            rtl={rtl}
                            readOnly
                            placeholder={t('Category')}
                            headingleft={t('Category')}
                            className='deliveryNotes_TextField'
                            value={category}
                        />
                    </Form.Item>

                    <Form.Item>
                        <div className='form__StickyContainer'>
                            <div className='FSTC__Box'>
                                <div className='STB__TnC'>
                                    <input aria-label='checkbox' type='checkbox' onChange={handleCheckbox} className='STB__Checkbox' />
                                    <Typography rtl={rtl} id="lineType-heading" className='STB__Text'>
                                        {t('Accept_TermsNcondition')}
                                        <a href={`${window.location.protocol}//${window.location.host}/web/en/general/ftthodbrequest/terms-and-conditions`} target='_blank' rel="noreferrer" >{t(`Terms_Condition`)}</a>
                                    </Typography>
                                </div>
                                <Button
                                    primary={true}
                                    rtl={rtl}
                                    variant={!checked ? 'disabled' : 'default'}
                                    htmlType={'submit'}
                                >
                                    {t('Submit')}
                                </Button>
                            </div>
                        </div>
                    </Form.Item>
                </Form>
            </ConfigProvider>
        </div>
    )
}

export default NotifyForm